// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"9015ca24","206":"74dfd97c","235":"0d33a78a","406":"cb217090","512":"4bfb7724","539":"d50f4a95","732":"d50f4a95","952":"aa1bdef8"}[chunkId] + ".chunk.css";
};